import React from 'react';

import {observer} from "mobx-react";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import styles from "../styles/entity-scores-widget.module.scss";
import classNames from "classnames";
import {EntityScoresWidgetHeaderOddsToggle} from "./entity-scores-widget.header.odds-toggle";
import {EntityScoresWidgetDropdown} from "./entity-scores-widget.dropdown";

export class EntityScoresWidgetHeaderProps extends BaseProps {
}

export const EntityScoresWidgetFiltersHeader = observer(({controller}: EntityScoresWidgetHeaderProps) => {
  const {state} = controller;
  const {shouldRenderFiltersHeader} = state;

  return shouldRenderFiltersHeader ? <div className={classNames(styles.filters_header)}>
    <EntityScoresWidgetHeaderOddsToggle controller={controller}/>
    <EntityScoresWidgetDropdown controller={controller}/>
  </div> : null
});